// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"53f56bfedddb22e6f92c","293":"a68623cfec114073975d","518":"4325756e60f21fc4610a","779":"63cdbdc051f2852aa4ba"}[chunkId] + ".js";
};